import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withHandlers,
  lifecycle,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactSelectMaterialUi from 'react-select-material-ui';
import CloseButton from '../../components/atoms/CloseButton';
import GochiMenuDetailTableGroup from '../../components/molecules/GochiMenuDetailTableGroup';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    borderRadius: 4
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  tableContainer: {
    marginTop: 15
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    detail,
    updateOpenDetailModal,
    isLanguage,
    setIsLanguage,
    isFukuoka
  }) => {
    let { menuName, promotionDescription, description } = detail;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData) {
        ({ menuName, description } = languageData.params);
        promotionDescription = languageData.params.quantityFreeDes;
      }
    }
    const closeAction = () => updateOpenDetailModal(false);
    return (
      <div className={classes.root}>
        <Typography className={classes.title} variant="h6">
          {isFukuoka ? 'コース情報詳細' : 'メニュー情報詳細'}
        </Typography>
        <div className={classes.tableContainer}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <GochiMenuDetailTableGroup
            menuName={menuName}
            price={detail.price}
            taxTypeStr={detail.taxTypeStr}
            reducedTaxTypeStr={detail.reducedTaxTypeStr}
            description={description}
            tags={detail.tags}
            comboMenu={detail.comboMenu}
            priceCombo={detail.priceCombo}
            quantityRelease={detail.quantityRelease}
            quantityPromotion={detail.quantityPromotion}
            promotionDescription={promotionDescription}
            usageLimit={detail.usageLimit}
            expiration={detail.expiration}
            expirationEndDate={detail.expirationEndDate}
            image={detail.image}
            createdAt={detail.createdAt}
            updatedAt={detail.updatedAt}
            shopId={detail.shopId}
            shopName={detail.shopName}
            menuId={detail.menuId}
            subscription={detail.subscription}
            subscriptionIntervalCount={detail.subscriptionIntervalCount}
            subscriptionInterval={detail.subscriptionInterval}
            menuChildType={detail.menuChildType}
            shashokuOptionStr={detail.shashokuOptionStr}
            showHide={detail.showHide}
            genreName={detail.menuGenreName}
            situationNames={detail.menuSituationNames}
            userTargetNames={detail.menuUserTargetNames}
            menuLimitTotal={detail.menuLimitTotal}
            isFukuoka={isFukuoka}
          />
        </div>
        <div className={classes.tableContainer}>
          <CloseButton onClickAction={closeAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
